export const buildURLQueryFromObject = (obj: Map<string | number, string | number>):string => {
  let queryString = '?';
  obj.forEach((value, key) => {
    queryString = `${queryString}${key}=${value}&`;
  });
  return queryString.slice(0, -1);
};
